import Phaser from 'phaser';
import { BootScene } from './scenes/BootScene';
import { Preloader } from './scenes/Preloader';
import { GameScene } from './scenes/GameScene';

const config: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: 900,
  height: 700,
  parent: 'game-container',
  backgroundColor: '#2d5a27',
  pixelArt: true,
  roundPixels: true,
  antialias: false,
  scale: {
    mode: Phaser.Scale.RESIZE,
    autoCenter: Phaser.Scale.CENTER_BOTH,
    width: 900,
    height: 700
  },
  fps: {
    target: 60,
    forceSetTimeOut: true
  },
  scene: [BootScene, Preloader, GameScene]
};

new Phaser.Game(config);
